module.exports = __webpack_public_path__ + "img/approval.d276cbff.svg";